import PropTypes from 'prop-types';
export const articlePropTypes = {
  /**
   * Children element
   */
  children: PropTypes.node,
  /**
   * Html string containing html tags
   */
  html: PropTypes.string,
  /**
   * Gatsby API function
   */
  onSubscribe: PropTypes.func
};